import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
export const createFlightsQueries = (requests) => ({
    useListFlights: (params, options) => {
        return useQuery({
            queryKey: ["flights", "list", params],
            queryFn: () => requests.listFlights(params),
            ...options,
        });
    },
    useFindFlight: (params, options) => {
        return useQuery({
            queryKey: ["flights", "find", params],
            queryFn: () => requests.findFlight(params),
            ...options,
        });
    },
    useCreateFlight: (options) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: requests.createFlight,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["flights", "list"] });
            },
            ...options,
        });
    },
    useUpdateFlight: (options) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: (variables) => requests.updateFlight(variables.id, variables.payload),
            onSuccess: (_, variables) => {
                queryClient.invalidateQueries({ queryKey: ["flights"] });
            },
            ...options,
        });
    },
    useDeleteFlight: (options) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: requests.deleteFlight,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["flights", "list"] });
            },
            ...options,
        });
    },
    useAddEntriesToFlight: (options) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: (variables) => requests.addEntriesToFlight(variables.flightId, variables.entryIds),
            onSuccess: (_, variables) => {
                queryClient.invalidateQueries({ queryKey: ["flights"] });
                queryClient.invalidateQueries({ queryKey: ["entries"] });
            },
            ...options,
        });
    },
    useRemoveEntryFromFlight: (options) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: (variables) => requests.removeEntryFromFlight(variables.flightId, variables.entryId),
            onSuccess: (_, variables) => {
                queryClient.invalidateQueries({ queryKey: ["flights"] });
                queryClient.invalidateQueries({ queryKey: ["entries"] });
            },
            ...options,
        });
    },
    useAssignFlightToTable: (options) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: (variables) => requests.assignFlightToTable(variables.flightId, variables.tableId),
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["flights"] });
                queryClient.invalidateQueries({ queryKey: ["contestsEditionsStagesTables"] });
            },
            ...options,
        });
    },
    useCloseFlight: (options) => {
        const queryClient = useQueryClient();
        return useMutation({
            mutationFn: requests.closeFlight,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["flights"] });
            },
            ...options,
        });
    },
});
//# sourceMappingURL=index.js.map